import React from 'react'
import {Spinner} from 'wix-ui-tpa'
import {Button, ButtonPriority, ButtonSize, HoverStyles} from 'wix-ui-tpa/cssVars'
import {addTicketsToCart as addTicketsToCartAction} from '../../../../../actions/reservation'
import {useAppActions, useAppSelector} from '../../../../../hooks/runtime'
import {isRequestPending} from '../../../../../selectors/pending-requests'
import {classes} from './add-to-cart.st.css'

export const AddToCart = () => {
  const {addTicketsToCart} = useAppActions()
  const loading = useAppSelector(state => isRequestPending(state, addTicketsToCartAction.typePrefix))

  return (
    <Button
      fullWidth
      hoverStyle={HoverStyles.underline}
      size={ButtonSize.large}
      priority={ButtonPriority.secondary}
      onClick={() => addTicketsToCart()}
      className={classes.button}
    >
      {loading ? <Spinner diameter={16} /> : 'Add to cart'}
    </Button>
  )
}
